/* iTOVi — scroll-driven FACE SCAN visualization.
   Renders the MediaPipe-canonical 468-point FaceMesh tessellation over the portrait.
   As a beam sweeps, the mesh draws itself in (top→bottom), a live counter climbs to 468,
   the forehead/cheek rPPG regions begin pulsing at the read heart-rate, then the wellness
   metrics count up and lock.
   Desktop: scroll scrubs the scan. Mobile / reduced-motion: it plays once in view. */
(function(){
  const track = document.querySelector('.fscan-track');
  if (!track) return;
  const wrap    = track.querySelector('.fscan-face-wrap');
  const beam    = track.querySelector('.fscan-beam');
  const mesh    = track.querySelector('.fscan-mesh');
  const reticle = track.querySelector('.fscan-reticle');
  const pulse   = track.querySelector('.fscan-pulse');
  const statusEl= track.querySelector('.fscan-status .s-text');
  const lmCount = track.querySelector('.lm-count');
  const metrics = [...track.querySelectorAll('.fscan-metric')];
  const reduce  = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isMobile= () => matchMedia('(max-width:820px)').matches;

  const easeOut = t => 1 - Math.pow(1 - t, 3);
  const clamp = v => Math.min(1, Math.max(0, v));
  const conf  = metrics.map(m => ({ target:+m.dataset.target||0, dec:+m.dataset.dec||0, el:m.querySelector('b') }));
  const fmt   = (v,dec) => dec ? v.toFixed(dec) : String(Math.round(v));

  /* ---- build the 468-point FaceMesh from the MediaPipe canonical topology ---- */
  let tess=null, ptsG=null, keyG=null, NPTS=468;
  (function buildMesh(){
    const D = window.ITOVI_FACEMESH;
    if (!D || !mesh) return;
    NPTS = D.n || D.pts.length;
    const NS='http://www.w3.org/2000/svg';
    const svg=document.createElementNS(NS,'svg');
    svg.setAttribute('viewBox','0 0 '+D.vb[0]+' '+D.vb[1]);
    svg.setAttribute('preserveAspectRatio','none');
    svg.setAttribute('class','fscan-mesh-svg');
    tess=document.createElementNS(NS,'path');
    tess.setAttribute('d',D.path); tess.setAttribute('pathLength','1'); tess.setAttribute('class','mesh-tess');
    svg.appendChild(tess);
    ptsG=document.createElementNS(NS,'g'); ptsG.setAttribute('class','mesh-pts');
    D.pts.forEach(p=>{ const c=document.createElementNS(NS,'circle'); c.setAttribute('cx',p[0]); c.setAttribute('cy',p[1]); c.setAttribute('r','0.32'); ptsG.appendChild(c); });
    svg.appendChild(ptsG);
    keyG=document.createElementNS(NS,'g'); keyG.setAttribute('class','mesh-key');
    ['forehead','cheekL','cheekR'].forEach(k=>{ const p=D.key&&D.key[k]; if(!p) return;
      const c=document.createElementNS(NS,'circle'); c.setAttribute('cx',p[0]); c.setAttribute('cy',p[1]); c.setAttribute('r','3'); c.setAttribute('class','roi'); keyG.appendChild(c); });
    svg.appendChild(keyG);
    mesh.appendChild(svg);
  })();

  /* render the whole scene for a single progress value p (0..1) */
  function render(p){
    const scanP   = clamp(p / 0.48);              // sweep + mesh build
    const revealP = clamp((p - 0.42) / 0.5);      // metrics count up

    if (beam && wrap){
      beam.style.transform = 'translateY(' + (easeOut(scanP) * wrap.clientHeight) + 'px)';
      beam.style.opacity = (scanP > 0.02 && revealP < 0.15) ? '1' : '0';
    }
    if (mesh){
      mesh.style.opacity = scanP > 0.02 ? '1' : '0';
      if (tess) tess.style.strokeDashoffset = (1 - easeOut(scanP)).toFixed(3);   // draw mesh in, top→bottom
      if (ptsG) ptsG.style.opacity = clamp(scanP * 1.25).toFixed(3);
      if (keyG) keyG.classList.toggle('on', scanP > 0.82);                       // rPPG regions begin pulsing
      if (lmCount) lmCount.textContent = Math.round(easeOut(scanP) * NPTS);
    }
    if (reticle) reticle.classList.toggle('on', scanP > 0.12);

    metrics.forEach((m,i) => {
      const t = clamp((revealP - i * 0.12) / 0.45);
      const c = conf[i];
      if (c.el) c.el.textContent = fmt(c.target * easeOut(t), c.dec);
      m.style.opacity = String(clamp(t * 1.4));
      m.style.transform = 'translateY(' + ((1 - clamp(t)) * 14) + 'px)';
      m.classList.toggle('locked', t >= 0.99);
    });
    if (pulse) pulse.classList.toggle('draw', revealP > 0.55);

    if (statusEl){
      statusEl.textContent =
        scanP   < 0.32 ? 'Detecting face…' :
        scanP   < 0.7  ? 'Reading heart rate…' :
        scanP   < 0.97 ? 'Reading breathing & stress…' :
        revealP < 0.6  ? 'Building your report…' : 'Wellness report ready';
    }
  }

  function onScroll(){
    const rect = track.getBoundingClientRect();
    const total = track.offsetHeight - window.innerHeight;
    render(total > 0 ? clamp(-rect.top / total) : 0);
  }

  /* timed one-shot playthrough for mobile / non-scrollable layouts */
  function playOnce(){
    const dur = 2600, start = performance.now();
    (function step(now){
      const p = clamp((now - start) / dur);
      render(p);
      if (p < 1) requestAnimationFrame(step);
    })(start);
    setTimeout(() => render(1), dur + 250);   // guarantee final state if rAF is throttled
  }

  if (reduce){ render(1); return; }

  if (isMobile() || (track.offsetHeight - window.innerHeight) <= 0){
    let played = false;
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting && !played){ played = true; playOnce(); } });
    }, { threshold: 0.35 });
    io.observe(wrap || track);
    render(0);
    return;
  }

  var _rafT=false;function _onScrollT(){if(_rafT)return;_rafT=true;requestAnimationFrame(function(){onScroll();_rafT=false;});}window.addEventListener('scroll', _onScrollT, { passive:true });
  window.addEventListener('resize', onScroll, { passive:true });
  onScroll();
})();
